import { render, staticRenderFns } from "./FaceManage.vue?vue&type=template&id=27933194&scoped=true"
import script from "./FaceManage.vue?vue&type=script&lang=js"
export * from "./FaceManage.vue?vue&type=script&lang=js"
import style0 from "./FaceManage.vue?vue&type=style&index=0&id=27933194&prod&scoped=true&lang=css"
import style1 from "./FaceManage.vue?vue&type=style&index=1&id=27933194&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27933194",
  null
  
)

export default component.exports